/* eslint-disable */
import React, { Component } from 'react'
// import PropTypes from 'prop-types';
import { View, Text, TouchableOpacity, Image, TouchableHighlight } from 'react-native'
import styles from './Styles/PostWallListComponentStyle'
import { MEDIA_TYPE, VIEW_MODE } from '../Constant/index'
import IconPostWallComponent from '../Components/IconPostWallComponent';
import { getUri } from '../Lib/utils'
//import FastImage from 'react-native-fast-image'

export default class PostWallListComponent extends Component {
  render( ) {
    const { imageHeight, imageWidth, data, viewMode } = this.props
    if( ! data.PostId ) return <View style={{ backgroundColor: data.tileColor, width: imageWidth, height: imageHeight, borderWidth : 1, borderColor : 'white' }}/>
    let thumbUrl = getUri(data.PostId)
    return (
      <TouchableOpacity activeOpacity={0.5} onPress={this.props.onPress} style={{ backgroundColor: data.tileColor, width: imageWidth, height: imageHeight }}>
        <View style={{ backgroundColor: 'transparent', flex: 1 }}>
          <View><Image style={{ width: imageWidth, height: imageHeight, borderColor: 'white', borderWidth: viewMode == VIEW_MODE.SINGLE ? 0 : 1 }} resizeMode="cover" source={{ uri: thumbUrl }}/></View>
          { this.props.viewMode == VIEW_MODE.GRID
              ? <View style={styles.icons}><IconPostWallComponent data={data}/></View>
              : <View/>
          }
        </View>
      </TouchableOpacity>
    )
  }
}
